<div ng-controller="FileExtensionController as ctrl" class="modal-view label-management">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>